import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Category } from '@app/shared/interfaces/Category';
import { NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd/tree';
import { CategoryService } from '@app/shared/services/Category.service';
import { MediaStructure } from '@app/shared/interfaces/MediaStructure';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { FormGroup } from '@angular/forms';
import { FormCategoryComponent } from '@app/forms/category/category.component';
import { HardCopy } from 'src/global-variables';
import {
  ConvertToAttributeValues,
  ConvertToFormAttributes,
} from '@product/shared/product-base-logic';
import { Attribute, AttributesGroup } from '@app/shared/interfaces/Attribute';
import { Translation } from '@app/shared/interfaces/Translation';
import { ObjectType } from '@product/shared/models/Enums.enum';
import { NzModalService } from 'ng-zorro-antd/modal';
import { OdataResponse } from '@app/shared/interfaces/odata-response';
import { Output, EventEmitter } from '@angular/core';
import { of, switchMap } from 'rxjs';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.less'],
})
export class CategoryComponent extends BaseComponent implements OnInit {
  @ViewChild('formComponent') categoriesComponent: FormCategoryComponent;
  data: Category[];
  nodes: any[];
  seleted: boolean;
  selectedKey: number | null = null;
  LinearNode: TreeNode[];
  NestedNode: TreeNode[];
  selectedNodes: NzTreeNode[];
  mostIndex: number = 0;
  searchValue: any;
  SaveCategories: Category[];
  activatedNode?: NzTreeNode;
  formGroup: FormGroup;
  componentModel: any;
  attributes: Attribute[];
  parentId: number = 0;
  canRemove: boolean = false;
  counter = 0;

  modal: NzModalService;
  categoryId:number=0;


  constructor( injector: Injector) {
    super(injector);
    this.modal = injector.get(NzModalService);
    this.formGroup = this.fb.group({});
    this.formGroup = this.fb.group(FormCategoryComponent.controls('create'));
    this.layoutService.pageTitle.next('Categories');
   // this.iconService.addIcon(FolderOpenOutline, FolderOutline);
  }

  ngOnInit(): void {
    this.seleted = false;
    this.LoadCategories();
    this.counter = 0;
  }

  fileList: MediaStructure[] = [];
  youtubeAPIKey = 'AIzaSyDliwVbYGfP9qkDjLPGMjvtL_Tz6m5hCHo';
  action = 'Media';
  deleteSelectedNodes() {
    if (this.selectedNodes === null || this.selectedNodes === undefined) {
      return;
    }
    this.selectedNodes.forEach((element) => {
      this.RemoveNode(element);
    });
  }
  OnSelect(event: any) {
    if (event.nodes.length === 0) {
      this.seleted = false;
    } else {
      this.seleted = true;
    }
    this.selectedNodes = event.nodes;
  }
  LoadCategories() {
    this.categoryService.GetAllGategories().subscribe((d: any) => {
      this.data = d.value;
      this.data = this.data.sort(
        (a, b) => (a.Position ?? 0) - (b.Position ?? 0)
      );
      this.TreeBuild();
      this.isLoading = false;
    });
  }
  onRefresh() {
    this.selectedKey = null;
    this.canRemove = false;
    this.formGroup.reset();

    this.ngOnInit();
  }
  onAttributeGroupsLoaded(groups: AttributesGroup[]) {
    if (groups == null) {
      return;
    }
    this.attributes = groups.flatMap((x) => x.Attributes!);
  }
  btnNewCategoryClicked() {
    this.selectedKey = null;
    setTimeout(() => {
      this.selectedKey = 0;
      for (let controlKey in this.formGroup.controls) {
        if (
          controlKey !== 'AttributeValues' &&
          controlKey !== 'ProductCategories'
        ) {
          this.formGroup.controls[controlKey].setValue(null);
        }
      }
      this.formGroup.get('ProductCategories')?.setValue([]);
      const attributeValues = this.formGroup.controls[
        'AttributeValues'
      ] as FormGroup;
      for (let controlKey in attributeValues.controls) {
        attributeValues.controls[controlKey].setValue(null);
      }
    }, 100);
  }
  activeNode(data: NzFormatEmitEvent): void {  
    this.selectedKey = null;
    this.activatedNode = data.node!;
    this.selectedKey = Number(this.activatedNode.key);
    this.categoryService.GetGategory(this.selectedKey).subscribe((d: any) => {
      const category = (d as OdataResponse).value[0];

      this.categoryId=category.Id
      this.getListPayload(category.Id)
      if (category != null) {
        this.canRemove = data.node!.children.length === 0;
        if (this.attributes == null && this.counter < 1) {
          setTimeout(() => {
            this.counter++;
            this.activeNode(data);
          }, 500);
          return;
        }
        this.counter = 0;
        category.AttributeValues = ConvertToFormAttributes(
          category.AttributeValues,
          this.attributes
        );
        if (category.AttributeValues == null) {
          const attributeValues = this.formGroup.controls[
            'AttributeValues'
          ] as FormGroup;
          for (let controlKey in attributeValues.controls) {
            attributeValues.controls[controlKey].setValue(null);
          }
        }


        this.formGroup.patchValue(category);
        setTimeout(() => {
          this.categoriesComponent.recordLoaded(category);
        }, 300);
      }
    });
  }

  CreateNewCategory(): void {
    let value = HardCopy(this.formGroup.value);

    const translations = value.Translations as Record<string, string>;
    const handledTranslations: Translation[] = [];
    if (translations != null && Object.keys(translations)) {
      Object.keys(translations).forEach((key) => {
        handledTranslations.push({
          Label: translations[key],
          LanguageId: +key,
          ObjectField: 'name',
          ObjectType: ObjectType.Category,
          ObjectId: 0,
        });
      });
    }
    var modifiedCat =
      this.categoriesComponent.beforeSubmit() as Category | null;
    if (modifiedCat != null) {
      value = modifiedCat;
    }
    value.Translations = handledTranslations;
    value.AttributeValues = ConvertToAttributeValues(value.AttributeValues, 0);
    value.ParentId = this.parentId == 0 ? undefined : this.parentId;
    value.Position = 0;
    if (value.ProductCategories == null) {
      delete value.ProductCategories;
    }
   this.categoryService.AddNewCategory(value).pipe(
  switchMap((cat: any) => {
    this.onRefresh();
    this.message.success('Category added successfully.');
    this.parentId = 0;
    if (this.listPayload != null) {
      return this.productCatalogService.addListPayload(cat.Id, 6, this.listPayload);
    } else {
      return of(null); 
    }
  })
).subscribe();
 
    // this.categoryService.AddNewCategory(value).subscribe((cat: any) => {
    //   this.onRefresh();
    //   console.log('Category : ',cat.Id);
      
    //   this.message.success('Category added successfully.');
    //   this.parentId = 0;
    // });

    
  }
  UpdateCategory() {
    const category = HardCopy(this.formGroup.value);
    category.AttributeValues = ConvertToAttributeValues(
      category.AttributeValues,
      0
    );
    const translations = category.Translations as Record<string, string>;
    const handledTranslations: Translation[] = [];
    if (translations != null && Object.keys(translations)) {
      Object.keys(translations).forEach((key) => {
        handledTranslations.push({
          Label: translations[key],
          LanguageId: +key,
          ObjectField: 'name',
          ObjectType: ObjectType.Category,
          ObjectId: this.selectedKey!,
        });
      });
    }
    category.Translations = handledTranslations;
    const prodCats = category.ProductCategories as any[];
    prodCats.map((cat) => {
      if (isNaN(cat.ProductId) && cat.ProductId.id != null) {
        cat.ProductId = cat.ProductId.id;
      } else {
        return cat.ProductId;
      }
    });
    category.Id = this.selectedKey;
    const ids = this.formGroup.get('ClonedCategories')?.value as number[];
    if (ids != null) {
      const categories = this.data.filter((cat) => ids.includes(cat.Id!));
      category.ClonedCategories = categories.map((x) => {
        return { Id: x.Id, Name: x.Name };
      });
    }
    this.categoryService.updateCategory(category).subscribe(() => {
  this.resetMediaStorageKeys();
  this.onRefresh();
  this.message.success('Category Updated successfully.');

  this.productCatalogService.editListPayload(category.Id, 6, this.listPayload).subscribe()
    }
  )
  
    // this.categoryService.updateCategory(category).subscribe(() => {
    //     this.resetMediaStorageKeys();
    //   this.onRefresh();
    //   this.message.success('Category Updated successfully.');
    // });
    // this.productCatalogService.editListPayload(category.Id,6, this.listPayload);
  }
  AddSubNode(event: NzTreeNode): void {
    this.selectedKey = null;
    setTimeout(() => {
      this.selectedKey = 0;
      const ParentNode = this.LinearNode.find(
        (x) => x.key === Number(event.key)
      );
      this.parentId = ParentNode!.key;
      for (let controlKey in this.formGroup.controls) {
        if (
          controlKey !== 'AttributeValues' &&
          controlKey !== 'ProductCategories'
        ) {
          this.formGroup.controls[controlKey].setValue(null);
        }
      }
      this.formGroup.get('ProductCategories')?.setValue([]);
      const attributeValues = this.formGroup.controls[
        'AttributeValues'
      ] as FormGroup;
      for (let controlKey in attributeValues.controls) {
        attributeValues.controls[controlKey].setValue(null);
      }
    }, 100);
  }
  RemoveNode(event: NzTreeNode): void {
    this.categoryService.RemoveCategory(+event.key).subscribe(() => {
      this.onRefresh();
      this.selectedKey = null!;
      this.message.success('Category deleted successfully.');
    });
  }

  AddRootCategory(){
    this.selectedKey = null;
    setTimeout(() => {
      this.selectedKey = 0;

      for (let controlKey in this.formGroup.controls) {
        if (
          controlKey !== 'AttributeValues' &&
          controlKey !== 'ProductCategories' &&
          controlKey !== 'Translations'
        ) {
          this.formGroup.controls[controlKey].setValue(null);
        }
      }
      this.formGroup.get('ProductCategories')?.setValue([]);
      const attributeValues = this.formGroup.controls[
        'AttributeValues'
      ] as FormGroup;
      for (let controlKey in attributeValues.controls) {
        attributeValues.controls[controlKey].setValue(null);
      }

      const translations = this.formGroup.controls[
        'Translations'
      ] as FormGroup;
      for (let controlKey in translations.controls) {
        translations.controls[controlKey].setValue(null);
      }
    }, 100);
  }

  AddSubCategory(): void {
    const parentKey = this.selectedKey;
    this.selectedKey = null;
    setTimeout(() => {
      const ParentNode = this.LinearNode.find(
        (x) => x.key === Number(parentKey)
      );
      this.parentId = ParentNode!.key;

      this.selectedKey = 0;

      for (let controlKey in this.formGroup.controls) {
        if (
          controlKey !== 'AttributeValues' &&
          controlKey !== 'ProductCategories' &&
          controlKey !== 'Translations'
        ) {
          this.formGroup.controls[controlKey].setValue(null);
        }
      }
      this.formGroup.get('ProductCategories')?.setValue([]);
      const attributeValues = this.formGroup.controls[
        'AttributeValues'
      ] as FormGroup;
      for (let controlKey in attributeValues.controls) {
        attributeValues.controls[controlKey].setValue(null);
      }

      const translations = this.formGroup.controls[
        'Translations'
      ] as FormGroup;
      for (let controlKey in translations.controls) {
        translations.controls[controlKey].setValue(null);
      }
    }, 100);
  }

  RemoveCategory(): void {
    this.modal.confirm({
      nzTitle: `Are you sure you want to delete this record?`,
      nzOnOk: () => {
        this.categoryService.RemoveCategory(Number(this.selectedKey)).subscribe(() => {
          this.onRefresh();
          this.selectedKey = null!;
          this.message.success('Category deleted successfully.');
        });
      },
    });
  }

  TreeBuild() {
    this.LinearNode = [];
    this.NestedNode = this.TreeNodesBuild(this.data);
    this.nodes = [...this.NestedNode];
  }
  TreeNodesBuild(Data: Category[]): TreeNode[] {
    let Result: TreeNode[] = [];
    Data.forEach((element) => {
      if (element.Id == null) {
        return;
      }
      if (this.mostIndex < element.Id) {
        this.mostIndex = element.Id + 1;
      }
      let node = new TreeNode();
      node.key = element.Id;
      node.title = element.Name + ` (#${element.Id})`;
      node.parent = element.ParentId ?? 0;
      node.Position = element.Position ?? 0;
      node.productsCount = element.ProductCategories?.length ?? 0;
      // node.children = [];
      if (!element.IsAdded) {
        this.LinearNode.push(node);
      }
      node.children = this.getChildCategories(element);
      node.isLeaf = node.children.length == 0;
      element.IsAdded = true;
      if (node.parent === 0) {
        Result = [...Result, node];
      }
    });


    return Result;
  }
  getChildCategories(parent: Category) {
    try {
      const children = this.data.filter((x) => x.ParentId == parent.Id);
      if (children.length == 0) return [];
      return children.map((x) => {
        const treeNode: TreeNode = new TreeNode();
        treeNode.key = x.Id!;
        treeNode.title = x.Name + ` (#${x.Id})`;
        treeNode.parent = x.ParentId ?? 0;
        treeNode.Position = x.Position ?? 0;
        treeNode.children = this.getChildCategories(x);
        treeNode.isLeaf = treeNode.children.length == 0;
        treeNode.productsCount = x.ProductCategories?.length ?? 0;
        return treeNode;
      });
    } catch (error) {
      // console.log(parent);
      // console.log(this.data);
      return [];
    }
  }
  valueChanged(event: any) {
    var tmp = this.LinearNode.find((x) => x.key == Number(event.key));
    if (tmp !== undefined) {
      tmp.isUpdated = true;
      tmp.title = event.val;
      let backendCat = this.GetBackEndCategory(tmp);
      this.categoryService.updateCategory(backendCat).subscribe();
    }
  }

  GetBackEndCategory(treeNode: TreeNode): Category {
    let tmpCat: Category = {
      Id: treeNode.isNew ? 0 : treeNode.key,
      ParentId: treeNode.parent,
      Name: treeNode.title,
      Position: treeNode.Position,
      toRemove: treeNode.isRemove,
      InverseParent: [],
      ProductCategories: [],
      Translations: [],
    };
    return tmpCat;
  }
  SaveCategory() {
    this.SaveCategories = [];

    this.LinearNode.forEach((element) => {
      if (
        !(element.isNew == true && element.isRemove == true) &&
        (element.isUpdated === true || element.isNew || element.isRemove)
      ) {
        let tmpCat: Category = {
          Id: element.isNew ? 0 : element.key,
          ParentId: element.parent,
          Name: element.title,
          Position: element.Position,
          toRemove: element.isRemove,
          InverseParent: [],
          ProductCategories: [],
          Translations: [],
        };
        this.SaveCategories.push(tmpCat);
      }
    });
  }
  CategoryDragEnd(event: any) {
    console.log(event);
    const dragedNode = event.node as NzTreeNode;
    const dragedCategory = this.data.find((x) => x.Id == +dragedNode.key);
    if (dragedCategory == null) {
      return;
    }
    const flattedNodes = this.flattenNodes(this.nodes);
    const node = flattedNodes.findIndex((x) => x.key === +dragedNode.key);
    const prevNode = flattedNodes[node - 1];
    const previosPosition = prevNode != null ? prevNode.Position : -1;
    const parentNode = event.node.parentNode;
    const parentCategory =
      parentNode == null
        ? null
        : this.data.find((x) => x.Id == +parentNode.key)!;
    this.subscriptions.push(
      this.categoryService
        .changeCategoryLevel(
          dragedCategory.Id!,
          previosPosition,
          parentCategory?.Id
        )
        .subscribe(() => {
          this.message.success('Category saved successfully');
        })
    );
  }
  flattenNodes(data: TreeNode[]): TreeNode[] {
    return data.flatMap((item) => [
      item,
      ...(item.children == null ? [] : this.flattenNodes(item.children)),
    ]);
  }
  
    resetMediaStorageKeys(): void {

    for (const key of Object.keys(localStorage)) {
      if (key.startsWith('mediaStorge-')) {
        localStorage.removeItem(key);
        break;
      }
    }
  }
//this.tabIndex === 'Smart' && 
listPayload:any;
handleDataFromChild(data: any) {
  this.listPayload=data;
  console.log('Received from child:',  this.listPayload);
 
}
  getListPayload(catalogId: number) {
    this.productCatalogService.getListPayload(catalogId,6).subscribe(
      {
        next: (response: any) => {
          if (response && response.payload) {

            this.listPayload.Filters = {
              ...response.payload.filters,
            };
           
          }


        }
      }
    );
  }
}
export class TreeNode {
  key: number;
  title: string;
  parent: number;
  isLeaf: boolean;
  children: TreeNode[];
  Position: number;
  isSelected: boolean;
  'InverseParent@odata.count': number;
  isNew: boolean;
  isRemove: boolean;
  isUpdated: boolean;
  productsCount: number;
}
